import {AssemblyModel} from "./AssemblyModel";

export enum MovieSlot {
    Background = "background",
    Prop = "prop",
    Character = "character",
    Animal = "animal",
}

export const MovieSlots = [
    MovieSlot.Background,
    MovieSlot.Character,
    MovieSlot.Prop,
    MovieSlot.Animal,
];

export type MovieModel = AssemblyModel<MovieSlot>;